import styled from "@emotion/styled";
import { LightMode, Variables } from "@repo/skapa";

// Adding border, background style. no layout (padding, gap)
export const CardContainer = styled.div<{
  backgroundColor?: string;
  border?: string;
}>`
  background-color: ${(props) =>
    props.backgroundColor ? props.backgroundColor : LightMode.colourNeutral1};

  ${(props) => (props.border ? `border: ${props.border}` : "")};
  border-radius: ${Variables.radiusS};
  overflow: hidden;

  ${({ onClick }) => (onClick !== undefined ? "cursor: pointer;" : "")}
`;
